// ══════════════════════════════════════════════════════
//  ACROX ASSISTANT — ACERO & CRISTAL MTY
//  Conexión Google Sheets vía Apps Script (JSONP + no-cors)
// ══════════════════════════════════════════════════════
const SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbxx49_pDC0c7_qv_1Be01IhPcotaeVo8DeI3N4mkGZjVoAEiI_s-KPN1JP4rbvBoNsF/exec';

export const SHEET_ID = '1paiRhfeg_KCp_z2bnNnSKDV7pLQLb4eZyCMiZDCYW1I';
export const SHEET_XLSX_URL = `https://docs.google.com/spreadsheets/d/${SHEET_ID}/export?format=xlsx`;

// JSONP para GET (evita CORS)
function jsonp(url) {
  return new Promise((resolve, reject) => {
    const cbName = 'cb_' + Math.random().toString(36).slice(2);
    window[cbName] = (data) => {
      resolve(data);
      delete window[cbName];
      document.body.removeChild(script);
    };
    const script = document.createElement('script');
    script.src = `${url}&callback=${cbName}`;
    script.onerror = () => {
      reject(new Error('JSONP error'));
      delete window[cbName];
      document.body.removeChild(script);
    };
    document.body.appendChild(script);
  });
}

// POST sin CORS
async function postTo(url, body) {
  try {
    await fetch(url, {
      method: 'POST', mode: 'no-cors',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    });
  } catch (e) { console.error('POST error:', e); }
}

export async function getLeads() {
  try {
    const d = await jsonp(`${SCRIPT_URL}?action=getLeads`);
    return d.leads || [];
  } catch (e) { return []; }
}

export async function updateLead({ rowIndex, ...fields }) {
  await postTo(SCRIPT_URL, { action: 'updateLead', rowIndex, ...fields });
}

export async function setEstatus(rowIndex, estatus) {
  await postTo(SCRIPT_URL, { action: 'setEstatus', rowIndex, estatus });
}

// FIX CRÍTICO de hora — Google Sheets serializa horas como fechas 1899
export function normalizeHour(val) {
  if (!val) return '';
  const s = String(val);
  const isoMatch = s.match(/T(\d{2}):(\d{2})/);
  if (isoMatch) return `${isoMatch[1]}:${isoMatch[2]}`;
  const legacyMatch = s.match(/\d{4}\s+(\d{2}):(\d{2}):\d{2}/);
  if (legacyMatch) return `${legacyMatch[1]}:${legacyMatch[2]}`;
  if (/^\d{2}:\d{2}/.test(s)) return s.slice(0, 5);
  return '';
}

export function normalizeDate(val) {
  if (!val) return '';
  const s = String(val);
  const m = s.match(/(\d{4})-(\d{2})-(\d{2})/);
  if (m) return m[0];
  const m2 = s.match(/(\d{1,2})\/(\d{1,2})\/(\d{4})/);
  if (m2) {
    const [, d, mo, y] = m2;
    return `${y}-${mo.padStart(2, '0')}-${d.padStart(2, '0')}`;
  }
  const dt = new Date(s);
  if (!isNaN(dt.getTime())) {
    return `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, '0')}-${String(dt.getDate()).padStart(2, '0')}`;
  }
  return '';
}

// ══════════════════════════════════════════════════════
//  INVENTARIO / CATÁLOGO
//  Apunta al MISMO Sheet que lee el agente de WhatsApp,
//  Messenger e Instagram: lo que cambies aquí, el bot lo
//  cotiza actualizado.
//  Columnas: id | nombre_producto | categoria | descripcion |
//            precio | colores_disponibles | foto_url |
//            monterrey | zacatecas | queretaro | rowIndex
// ══════════════════════════════════════════════════════

export const CATALOGO_SHEET_ID = '1SbJ9PN-Zabgg3M1Vw0EqhedOBFaITlOB1VCg5uQrkvQ';

// JSONP-POST: para escrituras que SÍ necesitan respuesta (subir foto y
// recibir la URL de Drive). Va por query params, así que el límite práctico
// ronda los 2 KB: por eso la imagen se reescala antes de convertirla.
function jsonpPost(payload) {
  return new Promise((resolve, reject) => {
    const cb = 'cb_' + Date.now() + '_' + Math.random().toString(36).slice(2);
    const script = document.createElement('script');
    const params = new URLSearchParams();
    Object.entries(payload).forEach(([k, v]) => params.append(k, String(v)));
    params.append('callback', cb);
    window[cb] = (data) => {
      delete window[cb];
      if (document.body.contains(script)) document.body.removeChild(script);
      resolve(data);
    };
    script.onerror = () => { delete window[cb]; reject(new Error('JSONP error')); };
    script.src = `${SCRIPT_URL}?${params.toString()}`;
    document.body.appendChild(script);
  });
}

export async function getStock() {
  try {
    const d = await jsonp(`${SCRIPT_URL}?action=getStock`);
    return d.stock || [];
  } catch (e) { return []; }
}

export async function addStockItem(item) {
  await postTo(SCRIPT_URL, { action: 'addStockItem', ...item });
}

export async function updateStockItem(rowIndex, item) {
  await postTo(SCRIPT_URL, { action: 'updateStockItem', rowIndex, ...item });
}

export async function deleteStockItem(rowIndex) {
  await postTo(SCRIPT_URL, { action: 'deleteStockItem', rowIndex });
}

// Sube la imagen a Drive y devuelve { ok, foto_url } con la URL pública
export async function uploadStockImage(base64, filename, mimeType) {
  return jsonpPost({ action: 'uploadStockImage', base64, filename, mimeType });
}
